/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import PropTypes from 'prop-types';

import { getHistory } from '../../../../../services/serviceRequest';
import RecordHistory from '../../../../../components/RecordHistory/RecordHistory';
import LoaderContext from '../../../../../context/LoaderProvider';
import useToast from '../../../../../hooks/useToast';

const RecordHistoryContainer = ({ setIsPendingAuthorization }) => {
  const { setNewToast } = useToast();
  const { setLoader } = useContext(LoaderContext);
  const [historyData, setHistoryData] = useState(null);

  useEffect(() => {
    setIsPendingAuthorization(false);
  }, []);

  const { id } = useParams();

  const getData = async (idSDS) => {
    try {
      const response = await getHistory(idSDS);
      const adapterResponse = response.map((record, index) => ({
        ...record,
        step: response.length - index
      }));

      setHistoryData(adapterResponse);
      setLoader(false);
    } catch (err) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
  };

  useEffect(() => {
    setLoader(true);
    getData(id);
  }, [id]);

  return historyData && <RecordHistory historyData={historyData} />;
};

RecordHistoryContainer.propTypes = {
  setIsPendingAuthorization: PropTypes.func
};

RecordHistoryContainer.defaultProps = {
  setIsPendingAuthorization: () => {}
};
export default RecordHistoryContainer;
